import useApiController from "@hooks/useApiController"

export default function useJuryController(): Admin.Controllers.Jury {
    const { index, store, show, update, destroy } = useApiController('/api/admin/juries')
    return { index, store, show, update, destroy }
}